import React from "react"
import { Link } from "gatsby"
const VideoTestimonial = props => {
  return (
    <div className="group flex flex-col justify-between bg-slate-800 hover:bg-slate-900 overflow-hidden rounded-md shadow-md col-span-1 mx-auto w-full transition-all">
      <div className="w-full aspect-[1/1.3]">
        <iframe
          className="w-full aspect-[1/1.3] bg-slate-800 group-hover:bg-slate-900 p-2 group-hover:p-0 transition-all"
          src={`https://player.vimeo.com/video/${props.videoId}`}
          title="Customer Testimonial"
          allow="autoplay; fullscreen"
          allowFullScreen
        ></iframe>
      </div>
      <div className="text-center pt-6 pb-8 px-3 transition-all">
        <p className=" text-slate-100/75 group-hover:text-slate-100 mb-2.5 text-xs font-semibold tranistion">
          "{props.quote}"
        </p>
        <p className="text-xs italic text-slate-400 group-hover:text-slate-300 mb-1.5 transition">
          {props.author || `Thomson Customer`}
        </p>
        <p className="text-xs italic text-slate-400 group-hover:text-slate-300 mb-2.5 transition">
          {props.company || ``}
        </p>
        <p className="text-xs italic text-slate-600 group-hover:text-slate-300 mb-6 transition">
          {props.location || ``}
        </p>
        <Link
          className="bg-blue-600/25 hover:bg-blue-600/35 px-2.5 py-2 rounded-md text-sm font-bold text-amber-200 hover:text-amber-300 transition"
          to={props.linkTo}
        >
          {props.linkText || "Learn More"}
        </Link>
      </div>
    </div>
  )
}

export default VideoTestimonial
// This component renders a video testimonial with a title and description.
